function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    isAuthenticated: false,
    account: null,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.GET_ME:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.GET_ME),
                    errors: unregisterAction(state.errors, actionTypes.GET_ME)
                });
            }
        case actionTypes.GET_ME_SUCCESS:
            {
                const { account } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    account,
                    fetching: unregisterAction(state.fetching, actionTypes.GET_ME)
                });
            }
        case actionTypes.GET_ME_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.GET_ME),
                    errors: registerAction(state.errors, actionTypes.GET_ME)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_IN_CALLBACK:
            {
                const { account } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: !!account,
                    account
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.LOAD_ACCOUNT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.LOAD_ACCOUNT),
                    errors: unregisterAction(state.errors, actionTypes.LOAD_ACCOUNT)
                });
            }
        case actionTypes.LOAD_ACCOUNT_SUCCESS:
            {
                const { account } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    account,
                    isAuthenticated: !!account,
                    fetching: unregisterAction(state.fetching, actionTypes.LOAD_ACCOUNT)
                });
            }
        case actionTypes.LOAD_ACCOUNT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.LOAD_ACCOUNT),
                    errors: registerAction(state.errors, actionTypes.LOAD_ACCOUNT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_OUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    sending: registerAction(state.sending, actionTypes.SIGN_OUT),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        case actionTypes.SIGN_OUT_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        case actionTypes.SIGN_OUT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SIGN_OUT),
                    errors: registerAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
